var React = require('react');

function List (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1C0 0.4 0.4 0 1 0H23C23.6 0 24 0.4 24 1V5C24 5.6 23.6 6 23 6H1C0.4 6 0 5.6 0 5V1Z","fill":"#181818","key":0}),React.createElement("path",{"d":"M1 9C0.4 9 0 9.4 0 10V14C0 14.6 0.4 15 1 15H23C23.6 15 24 14.6 24 14V10C24 9.4 23.6 9 23 9H1Z","fill":"#181818","key":1}),React.createElement("path",{"d":"M1 18C0.4 18 0 18.4 0 19V23C0 23.6 0.4 24 1 24H23C23.6 24 24 23.6 24 23V19C24 18.4 23.6 18 23 18H1Z","fill":"#181818","key":2})]);
}

List.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = List;

List.default = List;
